import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { COMPANY, tel } from "@/data/company";
import { Reveal } from "./Reveal";

export const CTABand = ({ title = "Have a roll to specify, recover or repair?", text = "Send us your application details — our engineering team will come back with a considered recommendation." }) => (
  <section className="relative bg-amber-brand text-ink overflow-hidden">
    <div className="absolute inset-0 bg-blueprint-light opacity-40" aria-hidden="true" />
    <div className="relative max-w-7xl mx-auto px-5 md:px-10 py-16 md:py-24 grid md:grid-cols-[1fr_auto] gap-10 items-center">
      <Reveal>
        <p className="font-mono-tech text-xs uppercase tracking-[0.25em] mb-4 text-ink/70">Start an enquiry</p>
        <h2 className="font-display font-black tracking-tight text-3xl md:text-5xl leading-[1.02] max-w-2xl">{title}</h2>
        <p className="mt-4 max-w-xl text-ink/80 text-base md:text-lg">{text}</p>
      </Reveal>
      <Reveal delay={0.15} className="flex flex-col gap-4">
        <Link
          to="/request-a-quote"
          data-testid="cta-band-quote-link"
          className="group inline-flex items-center justify-center gap-3 bg-ink text-steel-light font-display font-bold px-8 py-4 text-lg hover:bg-ink-3"
        >
          Request a Quote
          <ArrowRight size={20} className="transition-transform duration-300 group-hover:translate-x-1.5" />
        </Link>
        <a
          href={tel(COMPANY.phone.primary)}
          data-testid="cta-band-call-link"
          className="inline-flex items-center justify-center gap-3 border-2 border-ink/70 text-ink font-display font-bold px-8 py-3.5 hover:bg-ink hover:text-steel-light"
        >
          <Phone size={18} /> {COMPANY.phone.primary}
        </a>
      </Reveal>
    </div>
  </section>
);
